import * as React from 'react';
import { motion } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper } from './AnimateIcon';

const animations = {
  default: {
    needle: {
      initial: { rotate: 0, transformOrigin: '12px 8px' },
      animate: {
        rotate: [0, -25, 15, -10, 5, 0],
        transition: { duration: 0.6, ease: 'easeInOut' },
      },
    },
  },
};

function IconComponent({ size, ...props }) {
  const { controls } = useAnimateIconContext();
  const variants = getVariants(animations);

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="none"
      {...props}
    >
      <motion.g variants={variants.needle} initial="initial" animate={controls}>
        <path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v3.76z" />
        <rect x="11.25" y="17" width="1.5" height="5" rx="0.75" />
      </motion.g>
    </motion.svg>
  );
}

function Pin(props) {
  return <IconWrapper icon={IconComponent} {...props} />;
}

export { animations, Pin, Pin as PinIcon };
